import styled from 'styled-components'

export const FormContainer = styled.div`
  .card-title {
    position: absolute;
    top: -14px;
    left: 20px;
    padding: 5px 10px;
    font-size: 16px;
    background: #fff;
  }
  .card-container {
    position: relative;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    border: 4px solid #e4e6efcc;
    border-radius: 0.5rem;
    margin-bottom: 3rem;
  }
`
